import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

    user_role = "";
    club_id = "";
    associationData = {};
    is_parent_app_webview = false;

    constructor() {

    }
    ngOnInit() {
        var user_role = "";
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        user_role = currentUser.role;
        this.user_role = user_role;

        var associationData = JSON.parse(localStorage.getItem('sg_association_data'));
        this.associationData = associationData;

        var is_parent_app_webview = JSON.parse(localStorage.getItem('is_parent_app_webview'));
        if (is_parent_app_webview) {
            this.is_parent_app_webview = is_parent_app_webview;
        }

        if (user_role == "club_admin" || user_role == "club_staff") {
            this.club_id = currentUser.userdata.club_id_fk;
        }
    }
    ngAfterViewInit() {

        mLayout.initHeader();

    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts